import '@/lib/str';

export let endpoint_host = `https://${location.host}`;
let empresa_id = 1;
let empresa_titulo = 'Vila Rica'
if (/(localhost|drop.studiogt\.com\.br|sandbox\.sgt)/igm.test(location.host)) {
    endpoint_host = 'https://www.vilarica.com.br';
}
if (/(www\.)saoluiz\.imb\.br/igm.test(location.host) || /sao\-?lui[sz]/igm.test(location.pathname)) {
    endpoint_host = 'https://www.saoluiz.imb.br';
    empresa_id = 2;
    empresa_titulo = 'São Luiz'
}

if (/(localhost|drop.studiogt\.com\.br|sandbox\.sgt)/igm.test(location.host)) {
    //endpoint_host = `${location.protocol}//${location.host}/vila-rica-2020`;
}

export const empresa = {
    id: empresa_id,
    titulo: empresa_titulo,
    slug: empresa_titulo.slugify()
};

export const rest = {
    //endpoint: `${endpoint_host}/2019/rest`,
    endpoint: `${endpoint_host}/rest`,
    //search: `${endpoint_host}/2019`,
    search: `${endpoint_host}/importador`,
    imagens: `${endpoint_host}/media`
};

export const graphql = {
    endpoint: `${endpoint_host}/api/api.php`
};

export const Google = {
    apiKey: "AIzaSyAwWUoZgz5_fGDmKfGWZfU2TOwSuACjmHI"
};

